<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: "features",
  components: {SwiperSlide, Swiper},
  data() {
    return {
      list: [
        {text: 'Tasa de interés', strongText: 'competitiva'},
        {text: 'Pago inicial', strongText: 'a la medida'},
        {text: 'Plazos flexibles de', strongText: '12-72 meses'},
      ],
      // swiper配置
      swiperOption: {
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 30,
        mousewheel: true,
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
      },
    }
  },
}
</script>

<template>
  <div class="features">
    <swiper class="features__swiper" :options="swiperOption">
      <swiper-slide
          v-for="(item, index) in list"
          :key="index"
          class="features__slide"
      >
        <div class="features__item">
          <img class="features__icon" src="@/assets/imgs/features-item-icon.svg"/>
          <div class="features__title">
            {{ item.text }}
            <span class="features__title--strong">{{ item.strongText }}</span>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>

</template>

<style scoped lang="less">
.features {
  background: #020617;
  height: 1.5rem;
}

.features__swiper {
  height: 100%;
}

.features__item {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1rem;
  height: 100%;

  .features__icon {
    margin-right: 0.25rem;
  }

  .features__title {
    color: #FFF;
    font-size: 0.75rem;
    font-weight: 400;

    .features__title--strong {
      color: #0DE27D;
      font-weight: 500;
    }
  }
}


</style>